export default {
  boardInfo: {
    board: 'wooden',
    piece: 'neo_wood',
    mode: 'computer',
    moves: [],
    statusText: '',
  },
  user: null,
};
